// extracted by mini-css-extract-plugin
module.exports = {"base":"termsSelector_base__2eZDr","dropdownRowSelectAll":"termsSelector_dropdownRowSelectAll__3e5GJ"};